export default __webpack_public_path__ + "static/media/krukmgithub.2f576b92.png";